import { getCertificateSummary } from "@/api/certificates";
import { getWelders, WelderSearch } from "@/api/welders";
import { useQuery } from "react-query";

export function useGetWelders(skip: number, take: number, filters: WelderSearch) {
  const queryKey = ["welders", { skip, take, filters }];
  return useQuery(queryKey, () => getWelders(skip, take, filters));
}

export function useGetWelderCard(welderId: string, enabled: boolean) {
  const queryKey = ["certificates", { welderId }];
  return useQuery(queryKey, () => getCertificateSummary(welderId), { enabled });
}
